module.exports = __webpack_public_path__ + "static/media/iso-rocket.a9909640.svg";